import React, { Dispatch, SetStateAction } from 'react';

import COLORS from '~/constants/colors';
import Button from '~/components/buttons/Button';
import { FONT_SIZES, FONTS, FONT_WEIGHTS } from '~/constants/typography';
import VARIANTS from '~/constants/variants';

interface HiderProps {
  hidden: boolean;
  setHidden: Dispatch<SetStateAction<boolean>>;
}

function Hider({ hidden, setHidden }: HiderProps) {
  const label = hidden ? 'EDIT' : 'HIDE';

  // Handlers
  const toggleHidden = () => setHidden(!hidden);

  // Styling
  const buttonStyle = {
    float: 'right' as const,
    width: '4.3em',
    padding: '0.3em',
    fontFamily: FONTS.typewriter,
    fontWeight: FONT_WEIGHTS.normal,
    color: COLORS.doveGray,
    backgroundColor: COLORS.alto,
    borderColor: COLORS.transparent,
    borderRadius: '0.3em',
    fontSize: FONT_SIZES.text,
    boxShadow: `-0.07em 0.07em ${COLORS.black25}`,
  };

  return (
    <Button
      label={label}
      variant={VARIANTS.neutral}
      callback={toggleHidden}
      style={buttonStyle}
    />
  );
}

export default Hider;
